import { css } from '@/styled-system/css';

/**
 * Expanded container styles - full-width on all breakpoints
 */
export const expandedContainer = css({
  width: '100%',
  minHeight: '100%',
  bg: 'hpxWhite',
  position: 'relative',
  md: {
    minHeight: 'unset',
    height: '100%',
  },
});
